/* eslint-disable import/prefer-default-export */
/* eslint no-unused-vars: off */

export const enum AntivirusResponseStatus {
    NoThreatFound = 'NoThreatFound',
    ThreatFound = 'ThreatFound',
    FileNotFound = 'FileNotFound',
    Timeout = 'Timeout',
    Error = 'Error',
    FileDisinfected = 'FileDisinfected',
    NoScanning = 'NoScanning'
}

export const enum QDExternalModelByCustomerType {
    Commercial = 'Commercial',
    Consumer = 'Consumer'
}

export const enum WebDocumentStatus {
    Idle = 0,
    Sent = 1,
    Pending = 2,
    Received = 3,
    Uploaded = 4,
    Verified = 5,
    Cancaled = 6,
    Rejected = 7
}
